// extracted by mini-css-extract-plugin
export default {"headerBar":"vJ-z","pointsSection":"wJ-z","goToDashboard":"xJ-z"};